import styled from 'styled-components';

export const NewsContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const NewsWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const BoxWrapper = styled.div`
background: #fff;
border-radius: 10px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
width: 100%;
margin-bottom : 25px;
padding: 25px;
`;

export const NewsHeader = styled.h1`
font-size: 28px;
color: #33682c;
margin-bottom: 25px;
`;

export const NewsForm = styled.form`
display: flex;
flex-direction: column;
gap: 25px;
`;

export const NewsButton = styled.button`
width: 100%;
max-width: 200px;
height: 50px;
border-radius: 5px;
border: none;
background: rgb(51,104,44);
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
font-weight: bold;
margin-left: auto;
margin-right: auto;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}

&:disabled {
  color: #fff;
  background: #808080;

  &:hover {
    cursor: not-allowed;
    transform: scale(1);
    background: #808080;
}}
`;
export const NewsInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 100%;
padding-left: 5px;
transition: all 0.2s ease-in-out;

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}

@media screen and (max-width: 768px){
    width: 325px;
}

@media screen and (max-width: 480px){
    width: 275px;
}
`;

export const NewsLabel = styled.label`
font-size: 18px;
color: #000;
`;

export const InsideWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
`;

export const FeedbackText = styled.p`
font-size: 18px;
color: #000;
text-align: center;
`;
